import React, { useEffect, useState } from "react";
import GuestMenu from "../guests/GuestMenu";
import NavBar from "../common/NavBar";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const GuestDashboard = () => {
  const { t } = useTranslation();
  const [totalStays, setTotalStays] = useState(0); // Past bookings
  const [upcomingBookings, setUpcomingBookings] = useState(0); // Future bookings
  const [error, setError] = useState("");

  const getApiBaseUrl = () => {
    return process.env.REACT_APP_API_URL || "http://localhost:8000";
  };

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/bookings/?guest_id=${localStorage.getItem("user_id")}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          throw new Error(t("Failed to fetch bookings."));
        }

        const bookings = await response.json();
        const currentDate = new Date();

        // Split bookings into past and future
        const pastBookings = bookings.filter((booking) => new Date(booking.end_date) < currentDate);
        const futureBookings = bookings.filter((booking) => new Date(booking.start_date) >= currentDate);

        setTotalStays(pastBookings.length);
        setUpcomingBookings(futureBookings.length);
      } catch (error) {
        console.error("Error fetching bookings:", error);
        setError(t("Failed to load bookings. Please try again later."));
      }
    };

    fetchBookings();
  }, [t]);

  return (
    <div className="flex min-h-screen flex-col">
      <NavBar />
      <div className="flex flex-1">
        {/* Sidebar Menu */}
        <GuestMenu />

        {/* Main Content */}
        <div className="ml-64 p-6 w-full">
          <h1 className="text-3xl font-bold mb-4">{t("guest_dashboard")}</h1>
          <p className="text-gray-600">{t("manage_profile_bookings")}</p>

          {error && <p className="text-red-500 mt-4">{error}</p>}

          {/* Content Sections */}
          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="bg-blue-100 p-4 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold">{t("your_upcoming_bookings")}</h2>
              <p className="text-xl font-bold">{upcomingBookings}</p>
            </div>
            <div className="bg-green-100 p-4 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold">{t("total_stays")}</h2>
              <p className="text-xl font-bold">{totalStays}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GuestDashboard;